export default "__VITE_ASSET__B9N4OpV2__"